module.exports = __webpack_public_path__ + "img/userPosition.12ef9ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/userPosition.png
// module id = GUgH
// module chunks = 1 2